// common/features/team/player/toRosterCopyPayload.ts
import type { RosterCreatePayload } from '../../../services/team/rosterPlayer'
import type { RosterPlayerFormValues } from './types'

const trim = (v: string): string => (v ?? '').trim()

/**
 * Build the PUT body for adding an EXISTING player to a roster (the `/copy`
 * endpoint). Unlike create, this sends ONLY the roster fields — the BE keeps the
 * player's own personal profile (name, email, image, etc.), so we never echo
 * those back. The add-existing form shows name/email read-only purely for
 * confirmation; nothing personal is submitted. is_playing keeps the copied
 * player on the active roster. Image is handled by the separate image step.
 */
export const toRosterCopyPayload = (
  values: RosterPlayerFormValues
): RosterCreatePayload => {
  const body: RosterCreatePayload = {
    player_number: trim(values.playerNumber),
    player_type_id: parseInt(trim(values.positionId), 10),
    is_injured: Boolean(values.isInjured),
    is_affiliate: Boolean(values.isAffiliate),
    is_playing: true,
  }

  const customerId = trim(values.customerIdentifier)
  if (customerId !== '') {
    body.customer_identifier = customerId
  }

  // Salesforce ID (Canlan only; the field is hidden elsewhere so this stays '').
  const salesforceId = trim(values.salesforceId)
  if (salesforceId !== '') {
    body.sf_id = salesforceId
  }

  return body
}
